import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  PdfSettingsCustomImageModel,
  PdfSettingsCustomTextModel,
  PdfSettingsHeaderInfoModel,
  PdfSettingsLogoModel,
  PdfSettingsModel
} from '../../models';
import { PdfSettingsAlignEnum, PdfSettingsSizeEnum, PdfSettingsHeaderInfoBlocksEnum, PdfSettingsHeaderBlocksEnum } from '../../enums';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'rnpl-pdf-header',
  templateUrl: './pdf-header.component.html',
  styleUrls: ['./pdf-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfHeaderComponent  {

  public sizeEnum = PdfSettingsSizeEnum;
  public alignEnum = PdfSettingsAlignEnum;
  public headerBlocksEnum = PdfSettingsHeaderBlocksEnum;
  public headerInfoBlocksEnum = PdfSettingsHeaderInfoBlocksEnum;

  @Input() pdfSettings: PdfSettingsModel;
  @Input() currentShortYear: string;

  @Output() imageClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() textClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() logoClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() headerClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() deleteImageClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() deleteTextClicked: EventEmitter<null> = new EventEmitter<null>();
  @Output() settingsUpdated: EventEmitter<PdfSettingsModel> = new  EventEmitter<PdfSettingsModel>();

  public itemDropped(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.pdfSettings.settings.header.order, event.previousIndex, event.currentIndex);
    this.settingsUpdated.emit(this.pdfSettings)
  }

  public imageClick(): void {
    this.imageClicked.emit();
  }

  public textClick(): void {
    this.textClicked.emit();
  }

  public logoClick(): void {
    this.logoClicked.emit();
  }

  public headerClick(): void {
    this.headerClicked.emit();
  }

  public deleteImage(): void {
    this.deleteImageClicked.emit();
  }

  public deleteText(): void {
    this.deleteTextClicked.emit();
  }

  get logo(): PdfSettingsLogoModel {
    return this.pdfSettings.settings.logo;
  }

  get headerInfo(): PdfSettingsHeaderInfoModel {
    return this.pdfSettings.settings.header.headerInfo;
  }

  get text(): PdfSettingsCustomTextModel {
    return this.pdfSettings.settings.header.text;
  }

  get image(): PdfSettingsCustomImageModel {
    return this.pdfSettings.settings.header.image;
  }

}
